module.exports = __webpack_public_path__ + "img/lens-160-minus-06.f8f7d333.png";